import createVueComponent from '../createVueComponent';

const GanttChart = createVueComponent('GanttChartIcon', [
  ['path', { d: 'M8 6h10', key: '9lnwnk' }],
  ['path', { d: 'M6 12h9', key: '1g9pqf' }],
  ['path', { d: 'M11 18h7', key: 'c8dzvl' }],
]);

export default GanttChart;
